<template>
  <div class="tag-panel">
    <a class="tag" href="#" v-on:click.prevent.stop="$emit('handleShowAll')" 
      :class="{sel: selItem === 'all'}">{{ $nippets.allArtists.all }}</a>
    <gallery-tag v-for="gallery in galleries" :key="gallery.gallery_id" :galleryId="gallery.gallery_id" 
      v-on:change="handleEmitChangeGallery" :sel="selItem === gallery.url" />
    <div class="tag region" v-on:click.stop="changeRegion(region)">{{ region }}</div>
  </div>
</template>

<script>
import GalleryTag from '@/components/buttons/GalleryPortfolioTag.vue'
export default {
  components: {
    GalleryTag
  },
  props: {
    selItem: String,
    galleries: Array,
    region: String
  },
  methods: {
    handleEmitChangeGallery(gallery) {
      this.$emit('change', gallery)
    },
    changeRegion (region) {
      this.$emit('changeRegion', region)
    }
  }
}
</script>

<style>

</style>